import React from 'react';
import { createRoutesFromElements, RouteObject } from 'react-router';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import RootRoute from './root_route';
import { SUPPORTED_URL_REGIONS } from '@reverbdotcom/commons/src/url_helpers';
import RouteErrorDisplay from './route_error_display';

// Serves the given routes at the root path and, for international prefix
// routing, under every supported region prefix (the prefixes are literal
// paths, e.g. /en-fr/marketplace -- there is no :region param).
export default function buildRootRoutes(routes: React.ReactNode): RouteObject[] {
  return createRoutesFromElements(
    ['', ...SUPPORTED_URL_REGIONS].map((region) => (
      <Route
        key={`root-${region || 'default'}`}
        path={`/${region}`}
        Component={RootRoute}
        ErrorBoundary={RouteErrorDisplay}
      >
        {routes}
      </Route>
    )),
  );
}
